import { HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LocalStorageService, RootState } from '../../configuration';
import { ensureFreshAccessToken } from '../../api/Api';
import { PUBLIC_API_ENDPOINT } from '../../constants/platform';

export type ConnectionStatus = keyof typeof HubConnectionState;

const useConnectionBuilder = (url: string) => {
  const isAuthenticated = useSelector((state: RootState) => state.features.auth.profile);

  const [connection, setConnection] = useState<HubConnection | null>(null);

  useEffect(() => {
    const accessToken = LocalStorageService.getItem('accessToken');

    if (!accessToken) {
      return;
    }

    if (!connection) {
      const connect = new HubConnectionBuilder()
        .withUrl(`${PUBLIC_API_ENDPOINT}/${url}`, {
          transport: HttpTransportType.WebSockets,
          // Đọc vé hiện tại mỗi lần gọi (kết nối lại sau khi vé được refresh phải dùng vé mới).
          accessTokenFactory: async () => (await ensureFreshAccessToken()) || '',
          skipNegotiation: true,
        })
        .withAutomaticReconnect()
        // Warning: không log URL kết nối (chứa access_token) ra console như mức Information mặc định.
        .configureLogging(LogLevel.Warning)
        .build();

      setConnection(connect);
    }
  }, [isAuthenticated]);
  return { connection, setConnection };
};

export { useConnectionBuilder };
